import getAxiosInstance from "@/api/get-axios-instance"

const fetchCampaignTemplates = async () => await getAxiosInstance().get(`campaign-templates`)

const campaignTemplatesAPI = {
  fetchCampaignTemplates
}
export default campaignTemplatesAPI
